'use strict';

export function mainMenuInit() {
  const toggles = document.querySelectorAll('.submenu-toggle');

  toggles.forEach(toggle => {
    const submenuId = toggle.getAttribute('aria-controls');
    const submenu = document.getElementById(submenuId);

    // Ten toggle jest "persistent" jeżeli znajduje się wewnątrz wrappera .sidebar
    const isPersistent = Boolean(toggle.closest('.sidebar'));

    // znajdź <li> rodzica dla bieżącego toggle (użyjemy go do porównań)
    const toggleLi = toggle.closest('li');

    // Kliknięcie: otwórz/zamknij (zamknie tylko inne na tym samym poziomie, NIE przodków)
    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

      // Zamknij inne togglery, ale:
      // - nie zamykaj siebie
      // - nie zamykaj przodków (ancestor) — chcemy, żeby rodzic pozostał otwarty
      toggles.forEach(other => {
        if (other === toggle) return;

        const otherLi = other.closest('li');

        // jeśli otherLi jest przodkiem toggleLi, to go nie zamykamy
        if (otherLi && toggleLi && otherLi.contains(toggleLi)) return;

        const otherSub = document.getElementById(other.getAttribute('aria-controls'));
        other.setAttribute('aria-expanded', 'false');
        if (otherSub) {
          otherSub.setAttribute('aria-hidden', 'true');
          otherSub.classList.remove('active');
        }
      });

      // Toggle aktualnego
      toggle.setAttribute('aria-expanded', String(!isExpanded));
      if (submenu) {
        submenu.setAttribute('aria-hidden', String(isExpanded));
        submenu.classList.toggle('active', !isExpanded);
      }
    });

    // Jeśli nie jest persistent — zachowanie "hover"
    if (!isPersistent) {
      toggle.addEventListener('mouseleave', () => {
        if (document.querySelector('.page-header__menu-mobile')) return;
        toggle.setAttribute('aria-expanded', 'false');
        if (submenu) {
          submenu.setAttribute('aria-hidden', 'true');
          submenu.classList.remove('active');
        }
      });

      if (submenu) {
        submenu.addEventListener('mouseleave', () => {
          toggle.setAttribute('aria-expanded', 'false');
          submenu.setAttribute('aria-hidden', 'true');
          submenu.classList.remove('active');
        });
      }
    }

    // Dla persistent: nie dodajemy mouseleave — klasa pozostaje aż do kolejnego kliknięcia
  });
}
